<template>
  <div>
    <el-card>
      <div slot="header" class="toolbar">
        <span>会员信息</span>
      </div>

      <div class="search-bar search-wrap">
        <el-input v-model.trim="query.nickname" placeholder="请输入微信昵称" clearable style="width: 200px" @keyup.enter.native="handleSearch" />
        <el-input v-model.trim="query.phone" placeholder="请输入手机号" clearable style="width: 180px" @keyup.enter.native="handleSearch" />
        <el-select v-model="query.levelId" clearable placeholder="会员等级" style="width: 180px">
          <el-option v-for="item in levelOptions" :key="item.id" :label="item.levelName" :value="item.id" />
        </el-select>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </div>

      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="id" label="编号" width="90" />
        <el-table-column label="头像" width="90" align="center">
          <template slot-scope="{ row }">
            <el-avatar :src="row.avatarUrl" :size="44">{{ (row.nickname || '会').slice(0, 1) }}</el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="微信昵称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column prop="levelName" label="会员等级" width="120" align="center" />
        <el-table-column prop="availablePoints" label="可用积分" width="110" align="right" />
        <el-table-column prop="frozenPoints" label="冻结积分" width="110" align="right" />
        <el-table-column prop="statusText" label="状态" width="90" align="center" />
        <el-table-column prop="createTime" label="注册时间" width="170" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="$hasPermission('mall:member-user:grant-points')" type="text" @click="openGrantDialog(row)">派发积分</el-button>
            <el-button type="text" @click="showDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="query.page"
          :page-size="query.limit"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog title="会员详情" :visible.sync="detailVisible" width="780px">
      <div v-if="currentRow" class="detail-wrap">
        <div class="detail-head">
          <el-avatar :src="currentRow.avatarUrl" :size="56">{{ (currentRow.nickname || '会').slice(0, 1) }}</el-avatar>
          <div class="detail-head-text">
            <div class="detail-name">{{ currentRow.nickname || '-' }}</div>
            <div class="detail-sub">会员等级：{{ currentRow.levelName || '-' }} / 折扣：{{ formatDiscount(currentRow.discountRate) }}</div>
          </div>
        </div>

        <el-descriptions :column="2" border>
          <el-descriptions-item label="编号">{{ currentRow.id || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ currentRow.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="OpenID"><span class="break-text">{{ currentRow.openId || '-' }}</span></el-descriptions-item>
          <el-descriptions-item label="UnionID"><span class="break-text">{{ currentRow.unionId || '-' }}</span></el-descriptions-item>
          <el-descriptions-item label="可用积分">{{ currentRow.availablePoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="活动积分">{{ currentRow.activityPoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="消费积分">{{ currentRow.consumePoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="冻结积分">{{ currentRow.frozenPoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="等级积分">{{ currentRow.levelPoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="累计使用积分">{{ currentRow.totalUsedPoints || 0 }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ currentRow.statusText || '-' }}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ currentRow.createTime || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="派发积分" :visible.sync="grantVisible" width="540px" :close-on-click-modal="false">
      <el-form ref="grantFormRef" :model="grantForm" :rules="grantRules" label-width="100px">
        <el-form-item label="会员昵称">
          <el-input :value="currentRow ? currentRow.nickname : ''" disabled />
        </el-form-item>
        <el-form-item label="积分类型" prop="pointType">
          <el-select v-model="grantForm.pointType" style="width: 100%">
            <el-option label="活动积分（立即可用，默认一年过期）" value="activity" />
            <el-option label="消费积分（冻结10天后可用）" value="consume" />
          </el-select>
        </el-form-item>
        <el-form-item label="派发积分" prop="points">
          <el-input v-model.number="grantForm.points" placeholder="请输入整数，支持负数扣减积分" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="grantForm.remark" type="textarea" :rows="4" maxlength="100" show-word-limit placeholder="请输入派发备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="grantVisible = false">取消</el-button>
        <el-button v-if="$hasPermission('mall:member-user:grant-points')" type="primary" :loading="grantLoading" @click="submitGrant">确认派发</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return { page: 1, limit: 10, nickname: '', phone: '', levelId: null }
}

function defaultGrantForm () {
  return { pointType: 'activity', points: null, remark: '' }
}

export default {
  data () {
    const validatePoints = (rule, value, callback) => {
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入派发积分'))
        return
      }
      if (!Number.isInteger(value)) {
        callback(new Error('派发积分必须为整数'))
        return
      }
      if (value === 0) {
        callback(new Error('派发积分不能为0'))
        return
      }
      callback()
    }
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      levelOptions: [],
      detailVisible: false,
      currentRow: null,
      grantVisible: false,
      grantLoading: false,
      grantForm: defaultGrantForm(),
      grantRules: {
        pointType: [{ required: true, message: '请选择积分类型', trigger: 'change' }],
        points: [{ required: true, validator: validatePoints, trigger: 'blur' }],
        remark: [{ required: true, message: '请输入派发备注', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
    this.loadLevels()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/member-user/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    async loadLevels () {
      const { data } = await http.get('/mall/member-level/options')
      this.levelOptions = data.data || []
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    showDetail (row) {
      this.currentRow = { ...row }
      this.detailVisible = true
    },
    openGrantDialog (row) {
      if (row && row.id) {
        this.currentRow = { ...row }
      }
      this.grantForm = defaultGrantForm()
      this.grantVisible = true
      this.$nextTick(() => this.$refs.grantFormRef && this.$refs.grantFormRef.clearValidate())
    },
    submitGrant () {
      if (!this.currentRow || !this.currentRow.id) return
      this.$refs.grantFormRef.validate(async valid => {
        if (!valid) return
        this.grantLoading = true
        try {
          const { data } = await http.post('/mall/member-user/grant-points', {
            userId: this.currentRow.id,
            pointType: this.grantForm.pointType,
            points: this.grantForm.points,
            remark: this.grantForm.remark
          })
          if (data.code === 0) {
            const actionText = this.grantForm.points > 0 ? '派发' : '扣减'
            if (this.grantForm.pointType === 'consume') {
              this.$message.success(this.grantForm.points > 0 ? '消费积分已派发，冻结10天后可用' : `消费积分${actionText}成功`)
            } else {
              this.$message.success(`活动积分${actionText}成功`)
            }
            this.grantVisible = false
            this.load()
            if (this.detailVisible) {
              this.currentRow = {
                ...this.currentRow,
                ...(data.data || {})
              }
            }
          }
        } finally {
          this.grantLoading = false
        }
      })
    },
    formatDiscount (discountRate) {
      const value = Number(discountRate || 10)
      return value <= 10 ? `${value}折` : `${value}%`
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-head {
  display: flex;
  align-items: center;
  gap: 14px;
}

.detail-head-text {
  flex: 1;
}

.detail-name {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.detail-sub {
  margin-top: 4px;
  color: #6b7280;
}

.break-text {
  word-break: break-all;
}
</style>
